import { UAParser } from 'ua-parser-js';
import { DeviceUUID } from 'device-uuid';

export default class ContentCommonParams {
  constructor(data) {
    const uaParser = new UAParser(data?.userAgent);
    const uaParserResults = uaParser.getResult();
    this.dvc_br = uaParserResults.device.vendor;
    this.dvc_mod = uaParserResults.device.model;
    this.dvc_os = uaParserResults.os.name;
    this.dvc_os_ver = uaParserResults.os.version;
    this.dvc_ua = uaParserResults.ua;
    // eslint-disable-next-line no-undef
    this.dvc_lan = navigator.language || navigator.userLanguage;

    const uuid = new DeviceUUID().get();
    this.dvc_id = uuid || '--';

    // eslint-disable-next-line no-undef
    this.dvc_w = window.screen.width;
    // eslint-disable-next-line no-undef
    this.dvc_h = window.screen.height;
    const du = new DeviceUUID().parse();
    this.dvc_tp = du.isMobile ? 'mobile' : 'desktop';

    this.rq_or = 'clientside';
    this.plt_tp = 'web';
    this.sdk_tp = data?.sdkType || 'no-defined';

    this.rq_id = data?.requestId;
    this.sdk_ver = data?.sdkVersion;
    this.src = data?.source;
    this.pb_uid = data?.publisherId;
    this.pb_adunit = data?.publisherAdUnit;
    this.data = data?.data;
    this.bundle = data?.bundle;
    // this.src = player_utils.getRefererPage();
    // this.pb_uid = TAPPX_GLOBAL_PARAMS.pb_uid;
    // this.pb_adunit = TAPPX_GLOBAL_PARAMS.pb_adunit;
  }

  setRequestId(requestId) {
    this.rq_id = requestId;
    return this;
  }

  setSdkVersion(sdkVersion) {
    this.sdk_ver = sdkVersion;
    return this;
  }

  setSource(source) {
    this.src = source;
    return this;
  }

  setPublisherId(publisherId) {
    this.pb_uid = publisherId;
    return this;
  }

  setPublisherAdUnit(publisherAdUnit) {
    this.pb_adunit = publisherAdUnit;
    return this;
  }

  setData(data) {
    this.data = data;
    return this;
  }

  setTimeStamp(timestamp) {
    this.timestamp = timestamp;
    return this;
  }

  build() {
    return {
      rq_id: this.rq_id,
      rq_or: this.rq_or,
      plt_tp: this.plt_tp,
      dvc_id: this.dvc_id,
      dvc_br: this.dvc_br,
      dvc_mod: this.dvc_mod,
      dvc_os: this.dvc_os,
      dvc_os_ver: this.dvc_os_ver,
      dvc_ua: this.dvc_ua,
      dvc_lan: this.dvc_lan,
      dvc_w: this.dvc_w,
      dvc_h: this.dvc_h,
      dvc_tp: this.dvc_tp,
      sdk_ver: this.sdk_ver,
      bundle: this.bundle,
      pb_uid: this.pb_uid,
      pb_adunit: this.pb_adunit,
      sdk_tp: this.sdk_tp,
      src: this.src,
      data: this.data,
      timestamp: this.timestamp,
    };
  }
}
